<template>
  <tr class="shipping-method">
    <td>
      <strong class="method-name">
        {{ shippingMethod }}
      </strong>
      <div v-if="promotionDiscount" class="past-pickup-discount">
        {{ promotionDiscount.name }}
      </div>

      <div v-for="note in notes" :key="note.text" class="rate-explanation-text">
        - <a v-if="note.link" :href="note.link">{{ note.text }}</a>
        <template v-else>{{ note.text }}</template>
      </div>
      <div v-if="hasTracking" class="rate-explanation-text">
        - Includes tracking
      </div>
      <div v-if="!saturdayDelivery" class="rate-explanation-text">
        - <b>Does not include Saturday Delivery</b>
      </div>
      <div v-if="pickupNote" class="rate-explanation-text">
        - {{ pickupNote }}
      </div>
    </td>
    <td>
      <div v-if="displayPromotion" class="promotion-discount text-right">
        <span class="shipping-discount-original-rate">
          {{ displayPrice }}
        </span>
        {{ promotionDiscount.discounted_total }}
      </div>
      <template v-else>
        <zone-discount-breakdown
          v-if="zoneDiscount && zoneDiscount.discount_amount > 0"
          :shipping-method="shippingMethod"
          :original-rate="zoneDiscount.original_rate"
          :discount-percentage="zoneDiscount.discount_percentage"
          :discount-amount="zoneDiscount.discount_amount"
        />
        <div class="display-price text-right">
          {{ displayPrice }}
        </div>
      </template>
    </td>
  </tr>
</template>

<script>
  import ZoneDiscountBreakdown from "./zone-discount-breakdown"

  export default {
    components: {
      ZoneDiscountBreakdown,
    },
    props: {
      shippingMethod: {
        type: String,
        required: true,
      },
      timing: {
        type: String,
        required: false,
        default: null,
      },
      zoneDiscount: {
        type: Object,
        required: false,
        default: null,
      },
      notes: {
        type: Array,
        required: false,
        default: () => [],
      },
      displayPrice: {
        type: String,
        required: true,
      },
      promotionDiscount: {
        type: Object,
        required: false,
        default() {
          return {}
        },
      },
      hasTracking: {
        type: Boolean,
        required: false,
        default: true,
      },
      saturdayDelivery: {
        type: Boolean,
        required: false,
        default: true,
      },
      pickupNote: {
        type: String,
        required: false,
        default: null,
      },
    },
    computed: {
      displayPromotion() {
        return this.promotionDiscount && this.promotionDiscount.name
      },
    },
  }
</script>
